<template>
  <div class="notice-maintenance">
    <v-container>
      <v-card flat>
        <v-card-title>
          お知らせ表示メンテナンス
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="8"></v-col>
              <v-col cols="4" class="text-end">
                <v-btn outlined color="primary" @click="handleAddNew"
                  >新規お知らせ</v-btn
                >
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.title"
                  label="タイトル"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  label="本文"
                  v-model="editedItem.content"
                  auto-grow
                ></v-textarea>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="editedItem.start_date"
                  label="開始日"
                  type="date"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="editedItem.end_date"
                  label="終了日"
                  type="date"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <template v-else>
            <v-data-table :headers="headers" :items="notices">
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon>
                <!-- <v-icon small @click="deleteItem(item)">
                  mdi-delete
                </v-icon> -->
              </template>
            </v-data-table>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" :loading="updating" @click="handleUpdate">
            保存する
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  fetchMaintenanceNotices,
  updateMaintenanceNotice,
} from '../api/modules/notices';
import { isSuccessStatus } from '../utils/http';

export default {
  components: {},
  data: () => ({
    loading: false,
    notices: [],
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: 'タイトル', value: 'title' },
      { text: '内容', value: 'content', width: 500 },
      { text: '開始日', value: 'start_date' },
      { text: '終了日', value: 'end_date' },
      { text: '', value: 'actions', sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      id: 0,
      title: '',
      content: '',
      start_date: '',
      end_date: '',
    },
    defaultItem: {
      id: 0,
      title: '',
      content: '',
      start_date: '',
      end_date: '',
    },
    updating: false,
  }),
  computed: {
    ...mapGetters({
      accessToken: 'auth/accessToken',
    }),
  },
  methods: {
    handleAddNew() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },
    editItem(item) {
      this.editedIndex = this.notices.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.notices.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.notices.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async handleUpdate() {
      this.updating = true;
      const result = await updateMaintenanceNotice({
        id: this.editedItem.id,
        payload: this.editedItem,
        accessToken: this.accessToken,
      });
      if (isSuccessStatus(result.statusCode)) {
        alert('更新しました！');
        const updated = await fetchMaintenanceNotices({
          accessToken: this.accessToken,
        });
        if (isSuccessStatus(updated.statusCode)) {
          this.notices = updated.response;
        }
      }
      this.updating = false;
    },
  },
  async created() {
    const result = await fetchMaintenanceNotices({
      accessToken: this.accessToken,
    });
    if (isSuccessStatus(result.statusCode)) {
      this.notices = result.response;
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>

<style></style>
